<script setup>
import {useSystem} from "../../store/system";
import VueQrcode from 'vue-qrcode';
import {onActivated, onMounted} from "vue";

const systemStore = useSystem()

onMounted(() => {
  if (document.querySelector('.section__canvas--second4')) {
    VANTA.FOG({
      el: "#canvas4",
      mouseControls: true,
      touchControls: true,
      gyroControls: false,
      minHeight: 200.00,
      minWidth: 200.00,
      highlightColor: 0xA034FA,
      midtoneColor: 0xA034FA,
      lowlightColor: 0xE66C12,
      baseColor: 0x16142A,
      blurFactor: 0.90,
      speed: 5.70,
      zoom: 1.00
    })
  }

})

onActivated(() => {
  document.title = 'Free Bitcoin Mining App | Mobile Mining Made Easy | HexMiner';
  document.querySelector('meta[name="description"]').setAttribute('content', 'Mine Bitcoin on-the-go with HexMiner’s mobile app. Zero-cost\n' +
      'mining, instant withdrawals, and passive income crypto earnings.');
})
</script>

<template>

  <!-- download -->
  <section class="section section--head tw-pb-[10rem]">
    <div class="container">
      <div class="row">
        <!-- title -->
        <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3 col-xl-8 offset-xl-2">
          <div class="section__title">
            <h2>{{systemStore.getFrontModuleContent(23)?.title}}</h2>
            <p>{{systemStore.getFrontModuleContent(23)?.sub_title}}</p>
          </div>
        </div>
        <!-- end title -->
      </div>

      <div class="row">
        <!-- tabs content -->
        <div class="col-12 tw-text-center tw-pt-[30px]">
          <vue-qrcode
              class="tw-rounded-lg tw-inline-block"
              :color="{ dark: '#000000ff', light: '#ffffffff' }"
              type="image/jpeg"
              :value="systemStore.website.apk_donload_url"
              :scale="6"
              :margin="2"
          ></vue-qrcode>
        </div>
      </div>

      <div class="sm:tw-block md:tw-hidden text-center tw-mt-10">
        <a href="https://hexminer.vip/download" target="_blank">
          <button class="tw-bg-gradient-to-r tw-from-purple-500 tw-to-purple-700 tw-text-white tw-px-[1.5rem] tw-py-1 tw-rounded-lg" type="button">
            <font-awesome-icon class="tw-mr-2 tw-text-[1.5rem] tw-mb-[-6px]" :icon="['fab', 'android']" />
            <div class="tw-text-[14px]">Download Android</div>
          </button>
        </a>
        <a href="https://hexminer.vip/download" target="_blank">
          <button class="tw-mt-8 tw-bg-gradient-to-r tw-from-purple-500 tw-to-purple-700 tw-text-white tw-px-[1.5rem] tw-py-1 tw-rounded-lg" type="button">
            <font-awesome-icon class="tw-mr-2 tw-text-[1.6rem] tw-mb-[-5px]" :icon="['fab', 'apple']" />
            <div class="tw-text-[14px]">Download Iphone</div>
          </button>
        </a>
      </div>
    </div>
    <div class="tw-left-0 tw-top-0 tw-w-full tw-h-full section__canvas section__canvas--second4 tw-z-[-1]" id="canvas4"></div>
  </section>
  <!-- end download -->

  <!-- Discover Powerful Features -->
  <section class="section section--head tw-mt-[2rem]">
    <div class="container">
      <div class="row">
        <!-- title -->
        <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3 col-xl-8 offset-xl-2">
          <div class="section__title">
<!--            <h2>{{systemStore.getFrontModuleContent(6)?.title}}</h2>-->
            <h2>{{systemStore.getFrontModuleContent(24)?.title}}</h2>
            <p>{{systemStore.getFrontModuleContent(24)?.sub_title}}</p>
          </div>
        </div>
        <!-- end title -->
      </div>

      <el-row :gutter="systemStore.getIsMobile? 0: 30">
        <el-col class="mt-5" :span="24" :md="12"
                v-for="(item, index) in systemStore.getFrontModuleContent(24)?.json_data"
                :key="index">
          <div class="feature p-5 tw-h-full tw-justify-start tw-rounded-[10px]">
            <h3 class="feature__title">{{item.title}}</h3>
            <p class="feature__text">{{item.desc}}</p>

            <span class="screw screw--tl"></span>
            <span class="screw screw--bl"></span>
            <span class="screw screw--tr"></span>
            <span class="screw screw--big-br"></span>
          </div>
        </el-col>
      </el-row>
    </div>
  </section>
  <!-- end Discover Powerful Features -->

  <!-- join -->
  <section class="section">
    <div class="container">
      <div class="row tw-mt-10">
        <div class="col-12">
          <div class="roadmap mt-4 rounded-md card-bg-active !tw-justify-between" style="align-items: normal !important;">
            <el-row class="w-full">
              <el-col :span="24" :md="18">
                <div class="tw-text-[2rem] tw-font-bold">{{systemStore.getFrontModuleContent(23)?.title}}</div>
                <div class="tw-mt-[18px]">{{systemStore.getFrontModuleContent(23)?.sub_title}}</div>
              </el-col>
              <el-col :span="24" :md="6" class="md:tw-text-right xs:!tw-text-center">
                <vue-qrcode
                    class="tw-rounded-lg tw-inline-block xs:tw-mt-8 md:tw-mt-0"
                    :color="{ dark: '#000000ff', light: '#ffffffff' }"
                    type="image/jpeg"
                    :value="systemStore.website.apk_donload_url"
                    :scale="2.8"
                    :margin="2"
                ></vue-qrcode>
              </el-col>
            </el-row>

            <!-- design elements -->
            <span class="block-icon block-icon--purple">
              <i class="ti ti-topology-star-ring"></i>
            </span>
            <span class="screw screw--lines-bl"></span>
            <span class="screw screw--lines-br"></span>
            <span class="screw screw--lines-tr"></span>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- end join -->
</template>

<style scoped>

</style>
